/* eslint-disable jira/filename-case */
import { createContext, type Context } from 'react';
import noop from 'lodash/noop';

type FocusRestorationContextType = {
	shouldRestoreFocus: boolean;
	enableRestoreFocus: () => void;
	clearRestoreFocus: () => void;
};

export const FocusRestorationContext: Context<FocusRestorationContextType> =
	createContext<FocusRestorationContextType>({
		shouldRestoreFocus: false,
		enableRestoreFocus: noop,
		clearRestoreFocus: noop,
	});
